import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { profileApi } from '@pukka/api';
import { storage } from '@pukka/storage';
import { Button } from '@pukka/ui-components';
import { useSnapshot } from 'valtio';

import { BrandsPersistedState } from './Brands.state';

function BrandsInfoBanner({ persistedState = BrandsPersistedState }) {
  const { t } = useTranslation('library');
  const { data: profileData } = profileApi.useProfile();
  const { parentList } = useSnapshot(persistedState);
  const [show, setShow] = useState(true);

  const hasSeen = storage.get(`brandsInfoBannerSeen:${profileData?.id}`);
  const hasBrandButNoParent = parentList?.results.length === 1 && parentList?.results[0].id === -1;

  const handleClose = () => {
    setShow(false);

    storage.set(`brandsInfoBannerSeen:${profileData?.id}`, true);
  };

  return show && !hasSeen && hasBrandButNoParent ? (
    <div
      data-testid="brands-info-banner"
      className="relative mb-10 rounded-xl border-[0.5px] border-dashed border-blue-400 bg-blue-50 py-5 pl-6 pr-[58px] text-center text-sm text-neutral-700"
    >
      {t('brands.bannerDescription')}{' '}
      <a href="https://help.mokapos.com/s/?language=in" className="text-brand underline">
        {t('brands.bannerLink')}
      </a>
      <Button icon="close" variant="nude" className="absolute right-[10px] top-[12px]" onClick={handleClose} />
    </div>
  ) : null;
}

export { BrandsInfoBanner };
